<template>
	<div class="essential-needs-calculator">
		<!--  <guide /> -->
		<div class="row">
			<div class="col s12">
				<div class="card">
					<div class="card-content row no-margins">
						<div class="col s12 no-padding title-section">
							<div class="item-title left">Flushing Toilets</div>
							<div class="right">
								<span class="inner-label">Total Water Consumption for 2 weeks:
								</span>
								<span class="inner-value">
									{{ $_displayFormat(flushingToilets.totalConsumption) }}
									gallons</span>
							</div>
							<div class="clear"></div>
						</div>
						<!--   <div class="row no-margins no-padding labels">
              <div class="col s4 no-padding">

              </div>
              <div class="col s4 ">

              </div>
              <div class="col s4 no-padding">

                </div>
            </div> -->
						<div class="row no-padding">
							<div class="col s12 m4">
								<div class="new-label labels">
									Average Use per Person per Day
								</div>
								<input :disabled="userRole === 'subscriber'" id="ft_use_per_person" type="number"
									placeholder="Average # of flushes per person" min="0" v-model="flushingToilets.usePerPerson" @input="
										$_calculateTotal($event, 'flushingToilets', 'usePerPerson')
										" />
								<span class="label">Enter average total number of flushes per
									person per day.</span>
							</div>
							<div class="col s1 no-padding multiply">×</div>
							<div class="col s12 m3">
								<div class="new-label labels">
									Number of Persons in Household
								</div>
								<input :disabled="userRole === 'subscriber'" id="ft_total_person" type="number" placeholder="0" class=""
									min="0" v-model="flushingToilets.totalPerson" @input="
										$_calculateTotal($event, 'flushingToilets', 'totalPerson')
										" />
								<!--  <span class="label">Enter average total shower time (in minutes) per person. </span> -->
							</div>
							<div class="col s1 no-padding multiply">×</div>
							<div class="col s12 m4">
								<div class="new-label labels">
									Type of Fixture
									<span style="font-size: 13px">(Water Consumption Rating)</span>
								</div>
								<select name="ft_water_consumption_rating" :disabled="userRole === 'subscriber'"
									v-model="flushingToilets.waterConsumptionRating" class="browser-default"
									id="ft_water_consumption_rating" @change="
										$_calculateTotal($event, 'flushingToilets', 'totalPerson')
										">
									<option :value="0">Select option from list</option>
									<option :value="1.6">1.6 gal/flash – low-flush toilet</option>
									<option :value="3.5">
										3.5 gal/flush - newer standard toilets
									</option>
									<option :value="5">
										5 gal/flush - older standard toilets
									</option>
									<option :value="0">
										Other – enter your own value (gal/flush)
									</option>
								</select>
								<input :disabled="userRole === 'subscriber'" v-model="flushingToilets.other_waterConsumptionRating"
									id="shs_water_consumption_rating" type="number" placeholder="0" min="0"
									v-show="flushingToilets.waterConsumptionRating === 0" class="validate" @input="
										$_calculateTotal(
											$event,
											'flushingToilets',
											'other_waterConsumptionRating'
										)
										" />
							</div>
						</div>
						<div class="row no-margins">
							<div class="grey lighten-5" style="padding: 16px; margin-top: 12px">
								<b>How to Determine your Toilet Type </b>
								<p class="styled">
									The number of gallons per flush is marked on most newer model
									toilets (between the seat and tank or inside the tank – on the
									walls of the tank or on the lid itself).
								</p>
								<p class="styled">
									Tip: Toilets manufactured before 1985 use 5 to 7 gallons per
									flush. Toilets manufactured between 1985 and 1994 use 3.5
									gallons per flush. Since 1994, most toilets are designed to
									flush using only 1.6 gallons of water or less. Use this
									<a href="https://api.sldb.lc/wp-content/uploads/2021/09/toilet-flow-rate.pdf" target="_blank">
										simple guide</a>
									to help you determine how many gallons per flush your toilet
									uses.
								</p>
							</div>
						</div>
					</div>
				</div>

				<div class="card">
					<div class="card-content row no-margins">
						<div class="col s12 no-padding title-section">
							<div class="item-title left">Showering</div>
							<div class="right">
								<span class="inner-label">Total Water Consumption for 2 weeks:
								</span>
								<span class="inner-value">{{
									$_displayFormat(showering.totalConsumption)
								}}
									gallons</span>
							</div>
						</div>
						<!-- <div class="row no-margins no-padding labels">
              <div class="col s12 m6 no-padding">
                Average Use per Person per Day
              </div>
              <div class="col s4 ">
                Number of Persons in Household
              </div>
              <div class="col s4 no-padding ">
                Type of Fixture <br />(Water Consumption Rating)
              </div>
            </div> -->
						<div class="row no-margins no-padding">
							<div class="col s12 m4">
								<div class="new-label labels">
									Average Use per Person per Day
								</div>

								<input :disabled="userRole === 'subscriber'" id="sh_use_per_person" type="number" placeholder="0" class=""
									min="0" v-model="showering.usePerPerson"
									@input="$_calculateTotal($event, 'showering', 'usePerPerson')" />
								<span class="label labels">Average Shower Time per Person per Day
									Enter average total shower time (in
									minutes) per person per day.
								</span>
							</div>
							<div class="col s1 no-padding multiply">×</div>
							<div class="col s12 m3">
								<div class="new-label labels">
									Number of Persons in Household
								</div>
								<input :disabled="userRole === 'subscriber'" id="sh_total_person" type="number" placeholder="0" class=""
									min="0" v-model="showering.totalPerson" @input="$_calculateTotal($event, 'showering', 'totalPerson')" />
							</div>
							<div class="col s1 no-padding multiply">×</div>
							<div class="col s12 m4">
								<div class="new-label labels">
									Type of Fixture <br />(Water Consumption Rating)
								</div>
								<select :disabled="userRole === 'subscriber'" name="showering" v-model="showering.waterConsumptionRating"
									id="showering" @change="
										$_calculateTotal(
											$event,
											'showering',
											'waterConsumptionRating'
										)
										" class="browser-default">
									<option value="">Select an Option</option>
									<option :value="2">2.0 gal/min – low-flow showerhead</option>
									<option :value="2.5">
										2.5 gal/min - standard showerhead
									</option>
									<option value="0">
										Other – enter your own value (gal/min)
									</option>
								</select>
								<input :disabled="userRole === 'subscriber'" v-model="showering.other_waterConsumptionRating"
									id="sh_water_consumption_rating" type="number" placeholder="0" min="0"
									v-if="showering.waterConsumptionRating === '0'" class="validate" @input="
										$_calculateTotal(
											$event,
											'showering',
											'other_waterConsumptionRating'
										)
										" />
							</div>
						</div>

						<div class="row no-margins">
							<div class="grey lighten-5" style="padding: 16px; margin-top: 12px">
								<b>How to Determine your Showerhead Type</b>
								<p class="styled">
									Showerheads may or may not be labelled. Use this
									<a href="https://www.bbldwp.com/DocumentCenter/View/55/Determination-of-Low-Flow-Plumbing-Fixtures?bidId= "
										target="_blank">
										simple guide</a>
									to determine the flow rate of your showerhead, whether or not
									it is labelled.
								</p>
							</div>
						</div>
					</div>
				</div>

				<div class="card">
					<div class="card-content row no-margins">
						<div class="col s12 no-padding title-section">
							<div class="item-title left">
								Personal Hygiene,<br />
								Cleaning Surfaces, Cooking
							</div>
							<div class="right">
								<span class="inner-label">Total Water Consumption for 2 weeks:
								</span>
								<span class="inner-value">{{
									$_displayFormat(hygieneCleaningCooking.totalConsumption)
								}}
									gallons</span>
							</div>
						</div>
						<div class="row no-margins no-padding labels">
							<!-- <div class="col s4 no-padding">
								Average Use per Person per Day
							</div>
							<div class="col s4">Number of Persons in Household</div>
							<div class="col s4 no-padding">
								Type of Fixture <br />(Water Consumption Rating)
							</div> -->
						</div>
						<div class="row no-margins">

							<div class="col s12 m4">
								<div class="new-label labels">Average Use per Person per Day</div>
								<input :disabled="userRole === 'subscriber'" id="sh_use_per_person" type="number" placeholder="0" min="0"
									class="" v-model="hygieneCleaningCooking.usePerPerson" @input="
										$_calculateTotal(
											$event,
											'hygieneCleaningCooking',
											'usePerPerson'
										)
										" />
								<span class="label">Enter average total bathroom and kitchen
									faucet run time (in minutes) per person per
									day.
								</span>
							</div>
							<div class="col s1 no-padding multiply">×</div>
							<div class="col s12 m3">
								<div class="new-label labels">
									Number of Persons in Household
								</div>
								<input :disabled="userRole === 'subscriber'" id="sh_total_person" type="number" placeholder="0" min="0"
									class="" v-model="hygieneCleaningCooking.totalPerson" @input="
										$_calculateTotal(
											$event,
											'hygieneCleaningCooking',
											'totalPerson'
										)
										" />
							</div>
							<div class="col s1 no-padding multiply">×</div>
							<div class="col s12 m4">
								<div class="new-label labels">
									Type of Fixture <br />(Water Consumption Rating)
								</div>
								<select :disabled="userRole === 'subscriber'" v-model="hygieneCleaningCooking.waterConsumptionRating"
									name="hygienCleaning" @change="
										$_calculateTotal(
											$event,
											'hygieneCleaningCooking',
											'waterConsumptionRating'
										)
										" id="hygienCleaning" class="browser-default">
									<option value="">Select an Option</option>
									<option :value="1.5">1.5 gal/min – low-flow faucet</option>
									<option :value="2.2">
										2.2 gal/min - standard flow faucet
									</option>
									<option :value="0">
										Other - enter your own value (gal/min)
									</option>
								</select>

								<input v-model="hygieneCleaningCooking.other_waterConsumptionRating" id="shs_water_consumption_rating"
									type="number" placeholder="0" min="0" v-if="hygieneCleaningCooking.waterConsumptionRating === 0"
									class="validate" :disabled="userRole === 'subscriber'" @input="
										$_calculateTotal(
											$event,
											'hygieneCleaningCooking',
											'other_waterConsumptionRating'
										)
										" />
							</div>
						</div>

						<div class="row no-margins">
							<div class="grey lighten-5" style="padding: 16px; margin-top: 12px">
								<b>How to Determine your Faucet Type</b>
								<p class="styled">
									Faucets may or may not be labeled. Use this
									<a href="https://api.sldb.lc/wp-content/uploads/2021/09/faucet-flow-rate.pdf" target="_blank">
										simple guide</a>
									to determine the flow rate of your faucet, whether or not it is
									labeled.
								</p>
							</div>
						</div>
					</div>
				</div>

				<div class="card">
					<div class="card-content">
						<div class="floating-details right" style="padding-right: 8px">
							Subtotal: {{ $_displayFormat(subTotalX) }} gallons
						</div>
						<div class="clear"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import M from "materialize-css";
import { mapState } from 'vuex'
import Guide from "./guide.vue";
export default {
	name: "EssentialNeedsCalculator",
	components: {
		Guide,
	},
	props: {
		dataValue: {
			type: Object,
			default: () => { },
		},
	},
	data() {
		return {
			helperListeners: null,
			flushingToilets: {
				usePerPerson: "",
				totalPerson: "",
				waterConsumptionRating: "",
				other_waterConsumptionRating: "",
				totalConsumption: 0,
			},
			showering: {
				usePerPerson: "",
				totalPerson: "",
				waterConsumptionRating: "",
				other_waterConsumptionRating: "",
				totalConsumption: 0,
			},
			hygieneCleaningCooking: {
				usePerPerson: "",
				totalPerson: "",
				waterConsumptionRating: "",
				other_waterConsumptionRating: "",
				totalConsumption: 0,
			},
		};
	},
	mounted() {
		this.updateTextFields();
		this.$_getData();
		this.$emit("update", this.formDataX);
		this.$_setupHelpers();
		this.$_performEmptyCheck();
	},
	computed: {
		...mapState({
			user: (state) => state.User.user,
		}),
		userRole: {
			get() {
				return 'user'
				return this.user && this.user.roles.length > 0
					? this.user.roles[0]
					: false
			}
		},
		subTotalX() {
			let val =
				parseFloat(this.flushingToilets.totalConsumption || 0) +
				parseFloat(this.showering.totalConsumption || 0) +
				parseFloat(this.hygieneCleaningCooking.totalConsumption || 0);

			return val;
		},
		formDataX() {
			return {
				flushingToilets: this.flushingToilets,
				showering: this.showering,
				hygieneCleaningCooking: this.hygieneCleaningCooking,
				subTotal: this.subTotalX,
			};
		},
	},
	watch: {
		subTotalX() {
			this.$emit("update", this.formDataX);
		},
	},
	beforeDestroy() {
		this.$_clearHelpers();
	},
	methods: {
		$_displayFormat(val) {
			let newVal = parseInt(val);
			newVal = newVal.toLocaleString("en-Us", {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			});

			return newVal;
		},
		$_clearHelpers() {
			if (this.helperListeners) {
				this.helperListeners.forEach((x) => {
					x.removeEventLister("click", () => { });
				});
			}
		},
		$_setupHelpers() {
			//const helpers = this.$el.querySelectorAll("[helper-id]");
			this.helperListeners = this.$el.querySelectorAll("[helper-id]");

			if (this.helperListeners) {
				this.helperListeners.forEach((helperEl) => {
					helperEl.addEventListener("click", (event) => {
						event.preventDefault();
						const helperId = helperEl.getAttribute("helper-id");
						const styles = helperEl.getAttribute("helper-style");
						this.$store.dispatch("Helpers/setHelper_", {
							id: helperId,
							styles: styles ? styles : "",
						});
						/*  this.$store.dispatch("Helpers/setHelper", helperId); */
					});
				});
			}
		},
		updateTextFields() {
			setTimeout(() => {
				M.updateTextFields();
			});
		},
		$_getData() {
			if (this.dataValue && Object.keys(this.dataValue).length > 0) {
				this.flushingToilets = this.dataValue.flushingToilets;
				this.showering = this.dataValue.showering;
				this.hygieneCleaningCooking = this.dataValue.hygieneCleaningCooking;
			}
		},
		$_calculateTotal({ target: { value } }, prop, key, multiplier = 14) {
			const dataObj = Object.assign({}, this.$data[prop]);
			let keysList = Object.keys(dataObj).filter(
				(keyx) => keyx !== "totalConsumption"
			);
			if (key === "other_waterConsumptionRating") {
				const once = keysList.filter((x) => x !== "waterConsumptionRating");
				keysList = once;
			} else {
				const twice = keysList.filter(
					(x) => x !== "other_waterConsumptionRating"
				);
				keysList = twice;
				this.$data[prop]["other_waterConsumptionRating"] = 0;
			}

			const keysTotal = keysList.reduce((result, item, index) => {
				if (dataObj[item] === "") {
					dataObj[item] = 0;
				}
				if (index === 0) {
					result = dataObj[item];
				} else {
					result = result * parseFloat(dataObj[item]);
				}

				return result;
			}, 0);

			const totalCon = keysTotal * multiplier;

			this.$set(this.$data[prop], "totalConsumption", totalCon);
			this.$_performEmptyCheck();
		},
		$_performEmptyCheck() {
			const allValues = [
				this.flushingToilets,
				this.showering,
				this.hygieneCleaningCooking,
			];
			const val = Object.values(allValues).some(
				({
					usePerPerson,
					totalPerson,
					waterConsumptionRating,
					other_waterConsumptionRating,
					totalConsumption,
				}) =>
					usePerPerson ||
					totalPerson ||
					waterConsumptionRating ||
					other_waterConsumptionRating ||
					totalConsumption
			);
			this.$emit("standardEnable", val);
		},
	},
};
</script>
<style lang="scss" scoped>
.labels-header {
	display: inline-block;
	padding: 12px 2px;
	font-size: 12px;
	font-weight: 500;
	width: 100%;
	margin-top: -8px;
	z-index: 9;
	left: 0;
	/*   letter-spacing: 0.5px; */
	margin-bottom: 4px;
}

.title-col {
	font-size: 20px;
	/*   margin-bottom: 6px; */
}

.section-row {
	display: inline-block;
	width: 100%;

	.heading {
		background: #5374f8;
		margin: 0 0 8px 0px;
		border-radius: 5px;
		padding: 7px;
		font-size: 15px;
		color: white;

		i {
			margin-right: 4px;
			font-size: 18px;
			line-height: 22px;
		}
	}
}

.section-total {
	padding: 9px 5px;
	margin-bottom: 5px;
	border-radius: 6px;

	.total-bar {
		font-size: 20px;
		line-height: 36px;
	}
}

.essential-needs-calculator {
	/*   input {
    border: 1.5px solid rgba(0,0,0,0.2) !important;
  } */
	margin: 0px !important;

	.is-relative {
		position: relative;
	}

	.card {
		.card-content {
			padding: 24px !important;

			.column-row {
				display: inline-flex;
				border-bottom: 1px solid #d5d5d5;
				margin: 0px 10px;
				width: calc(100% - 12px);
				padding: 8px 0px;

				.label-meta {
					width: 100%;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					font-size: 16px;
				}

				input {
					margin-bottom: 0px;
				}
			}
		}

		.card-title {
			padding: 0px;
			font-size: 20px;
			margin: 0px;
			line-height: 22px;
			padding-bottom: 12px;
			display: flex;
			border-bottom: 1px solid rgba(0, 0, 0, 0.1);

			i {
				float: left;
				margin-right: 8px;
				line-height: 22px;
			}

			/*  .details {

      } */
		}

		.input-field {
			margin-bottom: 0px;
		}

		.custom-label {
			font-size: 15px;
			/*   letter-spacing: 0.5px; */
			/*    margin-bottom: 8px; */
		}

		.total-field {
			margin-top: 14px !important;
		}

		.total-value {
			font-size: 28px;
		}
	}

	.floating-details {
		font-size: 26px;
	}
}

.title-section {
	border-bottom: 1px solid rgba(0, 0, 0, 0.04);
	margin: 0px 0px 16px;
	padding-bottom: 10px !important;
}

.labels {
	/*  font-size: 13px; */
	/*  letter-spacing: 1px; */
	font-weight: 500;
	margin: 12px 0px 4px;
}

span.label {
	font-size: 12px;
	/* letter-spacing: .5px; */
	line-height: 1.4;
	display: inherit;
	margin-top: 4px;
}

span {
	&.inner-label {
		font-weight: 600 !important;
	}

	&.inner-value {
		font-weight: 600;
		color: #3e5cd4;
	}
}

.multiply {
	@media screen and (max-width: 600px) {
		text-align: center;
		font-size: 28px;
		margin-top: 12px;
		margin-left: 50% !important;
		transform: translateX(-50%);
	}

	@media screen and (min-width: 600px) {
		margin-top: 78px;
		width: max-content !important;
	}
}
</style>
<style lang="scss">
.essential-needs-calculator {
	.item-title {
		font-size: 20px;
		margin-bottom: 6px;
		color: #5374f8;
		line-height: 24px;
	}

	input {
		margin-bottom: 0px !important;
		font-size: 14px;
	}

	select.browser-default {
		display: block;
		font-size: 14px;
	}
}
</style>
